<template>
    <div :style="{marginBottom: requiredTopMargin}">
        <div class="x-navbar">
            <div>
                <system-alerts></system-alerts>
                <trial-countdown></trial-countdown>
                <billing-alerts></billing-alerts>
            </div>
            <div class="x-navbar-row">
                <div class="x-navbar-group">
                    <a class="x-navbar-brand" href="/">
                        <img :src="'/assets/images/logo.svg' | asset" alt="Logotipo Microsistec"
                             style="height: 28px; margin: 4px"/>
                    </a>
                </div>
                <div class="x-navbar-collapsable-menu" :class="{'x-navbar-collapsable-menu-visible': menuVisible}">
                    <div class="x-navbar-group" style="width: 100%">
                        <!--<div style="overflow-x: hidden; display: flex">
                            <div style="overflow: visible; display: flex">-->
                        <!-- forms -->
                        <div class="x-navbar-link x-navbar-dropdown"
                             :class="{active: match('/forms')}"
                             v-if="$can('view.customers') || $can('view.forms')">
                            <a :href="formsUrl"
                               data-close-others="true"
                               data-toggle="dropdown"
                               class="dropdown-toggle">
                                Negócios
                                <span class="caret"></span>
                            </a>
                            <ul class="dropdown-menu">
                                <template v-if="funnels.length > 0">
                                    <li v-for="funnel in funnels">
                                        <a :href="'/forms/new/' + funnel.id">
                                            <span :style="{display: 'inline-block', width: '8px', height: '8px', borderRadius: '50%', marginRight: '6px', background: funnel.color}"></span>{{ funnel.name }}
                                        </a>
                                    </li>
                                    <li role="separator" class="divider"></li>
                                </template>
                                <li v-if="$can('view.customers') && funnels.length === 0">
                                    <a :href="formsUrl">Funil</a>
                                </li>
                                <li v-if="$can('view.forms')">
                                    <a href="/forms/lead-bank">Banco de Leads</a>
                                </li>
                            </ul>
                        </div>
                        <!-- calendar -->
                        <div class="x-navbar-link" :class="{active: match('/calendar')}" v-if="$can('view.calendars')">
                            <a href="/calendar">Atividades</a>
                        </div>
                        <!-- customers -->
                        <div class="x-navbar-link x-navbar-dropdown"
                             :class="{active: match('/customers')}"
                             v-if="$can('view.customers') || $can('view_owners.properties')">
                            <a href="/customers"
                               data-close-others="true"
                               data-toggle="dropdown"
                               class="dropdown-toggle">
                                Clientes
                                <span class="caret"></span>
                            </a>
                            <ul class="dropdown-menu">
                                <li v-if="$can('view.customers')">
                                    <a href="/customers">Todos
                                        <menu_counter name="customers.total"></menu_counter>
                                    </a>
                                </li>
                                <li v-if="$can('view.customers')">
                                    <a href="/customers/contacts">Clientes
                                        <menu_counter name="customers.contacts"></menu_counter>
                                    </a>
                                </li>
                                <li v-if="$can('view.customers') || $can('view_owners.properties')">
                                    <a href="/customers/owners">Proprietários
                                        <menu_counter name="customers.owners"></menu_counter>
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <!-- properties -->
                        <div class="x-navbar-link x-navbar-dropdown"
                             :class="{active: match('/properties')}"
                             v-if="$can('view.properties')">
                            <a href="/properties"
                               data-close-others="true"
                               data-toggle="dropdown"
                               class="dropdown-toggle">
                                Imóveis
                                <span class="caret"></span>
                            </a>
                            <ul class="dropdown-menu">
                                <li v-if="$can('add.properties')">
                                    <a href="/properties/add">Cadastrar imóvel</a>
                                </li>
                                <li>
                                    <a :href="propertySearchUrl">Pesquisar imóveis
                                        <menu_counter name="properties.total"></menu_counter>
                                    </a>
                                </li>
                                <li v-if="$can('add.properties') && settings.properties['approval'] !== true">
                                    <a :href="propertyDraftsUrl">Rascunhos
                                        <menu_counter name="properties.is-draft"></menu_counter>
                                    </a>
                                </li>

                                <li v-if="preferences.searchVersion !== 2">
                                    <new-search-button :menu="true"></new-search-button>
                                </li>
                                <li v-if="settings.properties['approval'] === true">
                                    <a href="/properties/approval">Em Aprovação
                                        <menu_counter name="properties.in-approval"></menu_counter>
                                    </a>
                                </li>

                            </ul>
                        </div>
                        <!-- buildings -->
                        <div class="x-navbar-link x-navbar-dropdown"
                             :class="{active: match('/buildings')}"
                             v-if="$can('view.buildings')">
                            <a href="/properties"
                               data-close-others="true"
                               data-toggle="dropdown"
                               class="dropdown-toggle">
                                Empreendimentos
                                <span class="caret"></span>
                            </a>
                            <ul class="dropdown-menu">
                                <li v-if="$can('add.buildings')">
                                    <a href="/buildings/add">Cadastrar empreendimento</a>
                                </li>
                                <li>
                                    <a href="/buildings">Pesquisar empreedimentos
                                        <menu_counter name="buildings.total"></menu_counter>
                                    </a>
                                </li>
                                <li v-if="$can('add.properties')">
                                    <a href="/buildings/search/eyJ0eXBlIjoyLCJkcmFmdCI6dHJ1ZX0=">Rascunhos
                                        <menu_counter name="buildings.is-draft"></menu_counter>
                                    </a>
                                </li>
                                <li class="divider"></li>
                                <li>
                                    <a href="/buildings/developers">Incorporadoras
                                        <menu_counter name="customers.building-developers"></menu_counter>
                                    </a>
                                </li>
                                <li>
                                    <a href="/buildings/builders">Construtoras
                                        <menu_counter name="customers.building-builders"></menu_counter>
                                    </a>
                                </li>
                                <li>
                                    <a href="/buildings/managers">Administradoras
                                        <menu_counter name="customers.building-managers"></menu_counter>
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <!-- condominiums -->
                        <div class="x-navbar-link x-navbar-dropdown"
                             :class="{active: match('/condominiums')}"
                             v-if="$can('view.buildings')">
                            <a href="/condominiums"
                               data-close-others="true"
                               data-toggle="dropdown"
                               class="dropdown-toggle">
                                Condomínios
                                <span class="caret"></span>
                            </a>
                            <ul class="dropdown-menu">
                                <li v-if="$can('add.buildings')">
                                    <a href="/condominiums/add">Cadastrar condomínio</a>
                                </li>
                                <li>
                                    <a href="/condominiums">Pesquisar condomínios
                                        <menu_counter name="condominiums.total"></menu_counter>
                                    </a>
                                </li>
                                <li v-if="$can('add.buildings')">
                                    <a href="/condominiums/search/eyJ0eXBlIjoxLCJkcmFmdCI6dHJ1ZX0=">Rascunhos
                                        <menu_counter name="condominiums.is-draft"></menu_counter>
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <!-- reports -->
                        <div class="x-navbar-link x-navbar-dropdown"
                             :class="{active: match('/reports')}"
                             v-if="canSeeReports()">
                            <a href="/reports"
                               data-close-others="true"
                               data-toggle="dropdown"
                               class="dropdown-toggle">
                                Relatórios
                                <span class="caret"></span>
                            </a>
                            <ul class="dropdown-menu">
                                <li>
                                    <a href="/reports/new">Analíticos
                                        <span class="badge badge-success">Novo</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="/reports/forms">Inteligência</a>
                                </li>
                            </ul>
                        </div>
                        <!-- portals -->
                        <div class="x-navbar-link"
                             :class="{active: match('/portals')}"
                             v-if="$can('edit.portals') && portals.length < 1">
                            <a :href="portalsUrl">Portais</a>
                        </div>
                        <div class="x-navbar-link x-navbar-dropdown"
                             :class="{active: match('/portals')}"
                             v-if="$can('edit.portals') && portals.length > 0">
                            <a :href="portalsUrl"
                               data-close-others="true"
                               data-toggle="dropdown"
                               class="dropdown-toggle">
                                Portais
                                <span class="caret"></span>
                            </a>
                            <div class="dropdown-menu dropdown-menu-holder">
                                <div v-slimscroll style="max-height: 300px" height="">
                                    <ul class="dropdown-menu-list">
                                        <li>
                                            <a :href="portalsUrl">Todos</a>
                                        </li>
                                        <li v-for="portal in portals">
                                            <a :href="portalUrl(portal.alias)">{{ portal.name }}</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <!-- I.A -->
                        <div class="x-navbar-link x-navbar-dropdown" v-if="settings.hasAlbert">
                            <a data-close-others="true"
                               data-toggle="dropdown"
                               class="dropdown-toggle">
                                I.A
                                <span class="caret"></span>
                            </a>
                            <ul class="dropdown-menu">
                                <li>
                                    <a v-show="settings.hasAlbert" href="/properties/outdated-reports" title="Atualização de imóveis">Atualizações de imóveis</a>
                                    <a v-show="!settings.hasAlbert" href="/instance/contrate" title="Atualização de imóveis">Atualizações de imóveis</a>
                                </li>
                            </ul>
                        </div>

                        <!-- Ajuda -->
                        <div class="x-navbar-link x-navbar-dropdown">
                            <a data-close-others="true"
                               data-toggle="dropdown"
                               class="dropdown-toggle btn orange">
                               Ajuda
                                <span class="caret"></span>
                            </a>
                            <ul class="dropdown-menu">
                                <li>
                                    <a target="_blank" href="http://suporte.microsistec.digital/" title="Suporte">Dúvidas Frequentes</a>
                                </li>
                                <li>
                                    <a href="https://microsistec-academy.memberkit.com.br" title="Microsistec Academy" target="_blank">
                                        Microsistec Academy
                                    </a>
                                </li>
                                <li v-if="$can('manager.billing')">
                                    <a href="/installments" title="2° Voa de boletos">2° Via de boletos</a>
                                </li>
                            </ul>
                        </div>
                        <!--</div>
                    </div>-->
                    </div>
                    <div class="x-navbar-group">
                        <div class="x-navbar-link" v-if="website">
                            <a class="double-horizontal-padding"
                               :href="website['url']"
                               target="_blank"
                               data-toggle="tooltip"
                               title="Ver meu website"
                               v-tooltip
                               position="bottom">
                                <i class="fa fa-globe x-navbar-icon x-navbar-hide-collapsed"></i>
                                <span class="x-navbar-show-collapsed">Ver meu website</span>
                            </a>
                        </div>
<!--                        <div class="x-navbar-link">-->
<!--                            <a class="double-horizontal-padding"-->
<!--                               href="http://suporte.microsistec.digital/"-->
<!--                               target="_blank"-->
<!--                               data-toggle="tooltip"-->
<!--                               title="Suporte"-->
<!--                               v-tooltip-->
<!--                               position="bottom">-->
<!--                                <i class="fa fa-question-circle x-navbar-icon x-navbar-hide-collapsed"></i>-->
<!--                                <span class="x-navbar-show-collapsed">Suporte</span>-->
<!--                            </a>-->
<!--                        </div>-->
                        <div class="x-navbar-link x-navbar-dropdown">
                            <a href="javascript:;" class="dropdown-toggle" data-toggle="dropdown"
                               data-close-others="true">
                                <i class="fa fa-gear x-navbar-icon x-navbar-hide-collapsed"></i>
                                <span class="x-navbar-show-collapsed">Configurações</span>
                            </a>
                            <ul class="dropdown-menu x-navbar-mega-menu" style="left: auto; right: 0; padding: 15px">
                                <li>
                                    <div class="x-navbar-mega-menu-row">
                                        <div class="x-navbar-mega-menu-column" v-if="$can('edit.websites') || ( $can('manager.blog') && settings.hasBlog ) ">
                                            <h4 class="font-blue">Website</h4>
                                            <a href="/website-settings/general" v-if="$can('edit.websites')">Configurações do website</a>
                                            <a href="/website-settings/model" v-if="$can('edit.websites')">Logo e cores</a>
                                            <a href="/seo" v-if="$can('edit.websites')">Meta Tags</a>
                                            <a href="/popups" v-if="$can('edit.websites')">Popups</a>
                                            <a href="/testimonials" v-if="$can('edit.websites')">Depoimentos</a>
                                            <a href="/pages" v-if="$can('edit.websites')">Páginas extras</a>
                                            <a href="/url-redirects" v-if="$can('edit.websites')">Redirecionamento de URL</a>
                                            <a href="/banners" v-if="$can('edit.websites')">Banners</a>
                                            <a href="/watermark" v-if="$user.is_instance_owner">Marca d'água</a>
                                            <a href="/blog" v-if="$can('manager.blog') && settings.hasBlog">Blog</a>
                                        </div>
                                        <div class="x-navbar-mega-menu-column">
                                            <h4 class="font-blue">Sistema</h4>
                                            <a href="/installments" v-if="$can('manager.billing')">Meus Boletos</a>
                                            <a href="/users" v-if="$can('edit.users')">Usuários</a>
                                            <a href="/teams" v-if="$can('edit.teams')">Equipes</a>
                                            <a href="/branches" v-if="$can('edit.teams')">Matriz e Filiais</a>
                                            <a href="/goals" v-if="$can('edit.users')">Metas</a>
                                            <a href="/form-routing" v-if="$can('edit.users')">Rodízio de
                                                atendimentos</a>
                                            <div>
                                                <a href="/form-routing-history"
                                                   v-if="$can('manager.forms')"
                                                   v-tooltip title="Essa função está em Beta e pode apresentar instabilidades">
                                                    Histórico do rodízio
                                                </a>
                                            </div>
                                            <div>
                                                <a href="/inbox"
                                                   v-if="$user.is_instance_owner"
                                                   v-tooltip title="Essa função está em Beta e pode apresentar instabilidades">
                                                    Caixa de E-mails
                                                </a>
                                            </div>
                                            <a href="/files" v-if="$can('edit.websites')">Biblioteca de arquivos</a>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div class="x-navbar-mega-menu-row">
                                        <div class="x-navbar-mega-menu-column"
                                             v-if="$can('edit.portals') || $can('edit.websites')">
                                            <h4 class="font-blue">Integrações</h4>
                                            <a :href="portalsUrl" v-if="$can('edit.portals')">Portais</a>
                                            <a href="/website-settings/social" v-if="$can('edit.websites')">Redes
                                                Sociais</a>
                                        </div>
                                        <div class="x-navbar-mega-menu-column">
                                            <h4 class="font-blue">Configurações</h4>
                                            <a href="/notifications">Alertas e Notificações</a>
                                            <a href="javascript:;" v-if="exact('/')"
                                               v-on:click.prevent="showSettingsModal()">Área de trabalho</a>
                                            <a v-if="!exact('/')" href="/#settings">Área de trabalho</a>
                                            <a v-if="$can('edit.users')" href="/system-settings">Gerais</a>
                                            <a v-if="$can('manager.webhooks')" href="/webhooks">Webhooks</a>
                                        </div>
                                    </div>
                                </li>
                                <li v-if="$can('marketing.investment')">
                                    <div class="x-navbar-mega-menu-row">
                                        <div class="x-navbar-mega-menu-column">
                                            <h4 class="font-blue">Marketing</h4>
                                            <a href="/marketing/configs/investment">Investimento</a>
                                        </div>
                                        <div class="x-navbar-mega-menu-column" v-if="canSeeReports()">
                                            <h4 class="font-blue">Relatórios</h4>
                                            <a href="/reports">Inteligência</a>
                                            <a href="/summaries/property-by-status">Imóveis por Status</a>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="x-navbar-group x-navbar-collapsable-button-wrapper">
                    <button type="button" class="navbar-toggle" style="display: block" @click="toggleMenu()">
                        <span class="sr-only">Toggle navigation</span>
                        <span class="icon-bar" style="background: white"></span>
                        <span class="icon-bar" style="background: white"></span>
                        <span class="icon-bar" style="background: white"></span>
                    </button>
                </div>
                <div class="x-navbar-group">
                    <x-notifications></x-notifications>
                </div>
                <div class="x-navbar-group">
                    <x-tasks></x-tasks>
                </div>
                <div class="x-navbar-group">
                    <div class="x-navbar-link x-navbar-dropdown">
                        <a :href="'/users/' + $user.id"
                           data-close-others="true"
                           data-toggle="dropdown"
                           class="dropdown-toggle" v-el:menu-toggler>
                            <simple-user></simple-user>
                        </a>
                        <ul class="dropdown-menu" style="right: 0; left: auto">
                            <li style="padding-left: 15px; padding-right: 15px; padding-top: 15px; margin-bottom: 8px">
                                <detailed-user></detailed-user>
                            </li>
                            <li>
                                <a :href="'/users/' + $user.id" style="overflow: hidden;text-overflow: ellipsis;">
                                    Meus dados
                                </a>
                            </li>
                            <li>
                                <a href="/terms/tos" style="overflow: hidden;text-overflow: ellipsis;">
                                    Termos de uso
                                </a>
                                <a href="/terms/privacy_policy" style="overflow: hidden;text-overflow: ellipsis;">
                                    Política de Privacidade
                                </a>
                            </li>
                            <li class="divider"></li>
                            <li>
                                <a href="/logout">Sair</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    const R = require('ramda')
    const Vue = require('vue')
    const SCI = require('sci')
    const $ = require('jquery')
    const {client} = require('sci/helpers')
    const XNotifications = require('components/notifications/Navbar.vue')
    const XTasks = require('components/queue/Navbar.vue')
    const SimpleUser = require('./TopNavbar/SimpleUser.vue')
    const DetailedUser = require('./TopNavbar/DetailedUser.vue')
    const Mousetrap = require('mousetrap')
    const interfaceOptions = require('sci/helpers/interface-options')

    let previousMargin = []

    export default {
        components: {
            NewSearchButton: require('components/property/NewSearchButton.vue'),
            XNotifications,
            XTasks,
            SimpleUser,
            DetailedUser
        },
        data() {
            const instance = SCI.get('instance');
            console.log(instance)
            return {
                preferences: interfaceOptions.state,
                registeredTopMargin: previousMargin,
                requiredTopMargin: 0,
                menuVisible: false,
                portals: [],
                funnels: [],
                settings: {
                    properties: {
                        'approval': instance.overrides["sci.settings.properties.approval"]
                    },
                    hasAlbert: instance.overrides['albert'],
                    hasBlog: instance.overrides['blog'],
                    code: instance.code,
                    useNewPortals: instance.overrides['sci.settings.portals.use_new_portals'] === true,
                    useNewForms: instance.overrides['sci.settings.forms.use_new_forms'] === true
                }
            }
        },
        ready() {
            interfaceOptions.load()
            if (this.$can('edit.portals')) {
                client.silent().get(null, '/portals/list-installed').then((res) => {
                    this.portals = R.sortBy(_ => _.name, res.data)
                })
            }

            this.loadFunnels()

            Mousetrap.bind('f2', (e) => {
                $(this.$els.menuToggler).click()
                return false
            })

            SCI.bus().$on('remove-top-margin', ({id}) => {
                this.registeredTopMargin = this.registeredTopMargin.filter((i) => {
                    return i.id !== id
                })
                previousMargin = this.registeredTopMargin

                this.calculateTopMargin()
            })

            SCI.bus().$on('push-top-margin', ({id, size}) => {
                this.registeredTopMargin.push({id, size})

                previousMargin = this.registeredTopMargin

                this.calculateTopMargin()
            })

            this.calculateTopMargin()
        },
        computed: {
            propertySearchUrl() {
                return interfaceOptions.searchUrl()
            },
            propertyDraftsUrl() {
                return interfaceOptions.searchUrl(true)
            },
            website() {
                if (this.$user.websites && this.$user.websites.length > 0) {
                    return this.$user.websites[0]
                }

                return null
            },
            portalsUrl() {
                return this.settings.useNewPortals ? '/portals/new' : '/portals'
            },
            formsUrl() {
                return this.settings.useNewForms ? '/forms/new' : '/forms'
            }
        },
        methods: {
            loadFunnels() {
                if (this.settings.useNewForms && this.$can('view.forms')) {
                    client.silent().get(null, '/forms/groups').then((res) => {
                        this.funnels = res.data || []
                    }).catch((error) => {
                        console.error('Falha ao carregar funis da navbar', error)
                        this.funnels = []
                    })
                }
            },
            toggleMenu() {
                this.menuVisible = !this.menuVisible
            },
            portalUrl(alias) {
                return this.settings.useNewPortals ? `/portals/new/${alias}/select-properties` : `/portals/${alias}/select-properties`
            },
            match(path) {
                return location.pathname.startsWith(path)
            },
            exact(path) {
                return location.pathname === path
            },
            canSeeReports() {
                if (this.$user) {
                    const user = this.$user

                    return user.type === 3 || user.is_instance_owner || this.$can('view.reports')
                }
                return false
            },
            showSettingsModal() {
                SCI.bus().$emit('dashboard:show-settings-modal')
            },
            calculateTopMargin() {
                this.requiredTopMargin = this.registeredTopMargin.reduce((a, b) => {
                    return a + b.size
                }, 0) + 'px'

                window.$requiredTopMargin = this.registeredTopMargin.reduce((a, b) => {
                    return a + b.size
                }, 0)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// TopNavbar.vue?04940d61